module.exports = __webpack_public_path__ + "static/about_sec5-ca36e816794332af413b9c2da6207a67.png";